import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import { Image, Translate } from '@hydra/common/components';
import { Criterium, CriteriumSkeleton } from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

const useStyles = makeStyles(theme => ({
  image: {
    marginRight: theme.spacing(1),
    height: '16px',
    width: '16px'
  }
}));

export const Favicon = ({ criterium }) => {
  const classes = useStyles();
  const { data, url } = criterium;
  const { variant } = useReviewContext();

  let textKey = 'favicon_ko';
  let src;
  let faviconExist;

  if (Array.isArray(data)) {
    faviconExist = data.length > 0;
    textKey = faviconExist ? 'favicon_ok' : 'favicon_ko';
    src = data[0];
  } else {
    faviconExist = data && data.favicons.length > 0;
    if (faviconExist) {
      const cmsDefaultFavicon = data.favicons.find(favicon => favicon.isDefaultForCms);
      if (cmsDefaultFavicon) {
        textKey = 'favicon_warning';
        src = cmsDefaultFavicon.href;
      } else {
        textKey = 'favicon_ok';
        src = data.favicons[0].href;
      }
    }
  }

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url }}
    >
      {
        variant === 'nocrit'
          ? <CriteriumSkeleton width='50%' />
          : (
            <>
              {faviconExist ? <Image src={src} className={classes.image} /> : null}
              <Translate content={textKey} />
            </>
            )
      }
    </Criterium>
  );
};

Favicon.propTypes = {
  criterium: PropTypes.shape({
    url: PropTypes.string,
    data: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array
    ])
  })
};

export default React.memo(Favicon);
